
export class CustomAttributeSection {
  id: string;
  externalId: string | undefined;
  label: string | undefined;
  index: number;
  entity: string;
  customAttributeDefinitions: CustomAttributeDefinition[] | undefined;
  

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.label = payload.label;
      this.index = payload.index;
      this.entity = payload.entity;
      if(payload.customAttributeDefinitions) {
        this.customAttributeDefinitions = payload.customAttributeDefinitions.map((cad: any) => new CustomAttributeDefinition(cad));
        // sort by index
        this.customAttributeDefinitions?.sort((a, b) => a?.index - b?.index);
      }
    }
  }
  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of ApiKey
   */
   static createCustomAttributeSections(result: Array<any>): CustomAttributeSection[] {
    const customAttributeSections = new Array<CustomAttributeSection>();
    if (result) {
      result.map((key) => {
        customAttributeSections.push(new CustomAttributeSection(key));
      });
    }
    return customAttributeSections;
  }
}

export class CustomAttributeSectionInput {
  id: string;
  externalId: string | undefined;
  label: string;
  index: number;
  entity: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.label = payload.label;
      this.index = payload.index;
      this.entity = payload.entity;
    }
  }
}

export class CustomAttributeDefinition {
  id: string;
  externalId: string | undefined;
  customAttributeSection: CustomAttributeSection | undefined;
  entity: string;
  type: string;
  label: string;
  index: number;
  key: string;
  conversionExpression: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      if (payload.customAttributeSection) {
        this.customAttributeSection = new CustomAttributeSection(payload.customAttributeSection);
      }
      this.entity = payload.entity;
      this.type = payload.type;
      this.label = payload.label;
      this.index = payload.index;
      this.key = payload.key;
      this.conversionExpression = payload.conversionExpression;
    }
  }
}

export class CustomAttributeDefinitionInput {
  id: string;
  externalId: string | undefined;
  sectionId: string;
  entity: string;
  type: string;
  label: string;
  index: number;
  key: string;
  conversionExpression: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.entity = payload.entity;
      this.sectionId = payload.sectionId || payload.customAttributeSection?.id;
      this.type = payload.type;
      this.label = payload.label;
      this.index = payload.index;
      this.key = payload.key;
      this.conversionExpression = payload.conversionExpression;
    }
  }
}